import React, { useState, useEffect } from 'react';
import { SafeAreaView, StyleSheet, ScrollView } from 'react-native';
import { useTheme } from 'react-native-paper';
import CustomSurvey from '../../../components/SurveyBuilderComponent/Survey/CustomSurvey';
import { generateUniqueID } from '../../../components/SurveyBuilderComponent/CreateSurvey/CreateSurveyFunctions';

const CreateSurvey = (props) => {

    useEffect(() => {
        console.log("New Survey Not Saved");
    }, []);

    // useUnload(e => {
    //     e.preventDefault();
    //     e.returnValue = '';
    // });

    // TODO Change organization id when you want to support multiCple companies
    const [survey, setSurvey] = useState({
        id: generateUniqueID(), organization_id: "8F844600-801E-41C7-ABF0-27F80CDFB625", survey_name: "", instructions: "", other_header_info: "",
        require_login: true
    })

    const initialQId = generateUniqueID();
    const { colors } = useTheme()
    const styles = makeStyles(colors)

    // * state array of section each section contains array of questions 
    const [sectionQuestionList, setSectionQuestionList] = useState([{
        id: generateUniqueID(),
        survey_header_id: "",
        section_name: "",
        section_title: "",
        section_subheading: "",
        section_required_yn: 0,
        section_order: 0,
        section_questions: [{
            id: initialQId, parent_id: "", survey_section_id: "", input_type_id: generateUniqueID(), input_type_name: "Text", question_name: "",
            question_subtext: "", question_required_yn: 0, answer_required_yn: 0, option_group_id: "9EF9EC42-2E58-4CEF-93A4-4C3C63C2FBE0",
            allow_mutiple_option_answers_yn: 0, dependent_question_id: generateUniqueID(), dependent_question_option_id: generateUniqueID(),
            dependent_answer_id: generateUniqueID(), question_order: 0, question_weight: 0,
            question_options: [{
                id: generateUniqueID(),
                question_id: initialQId,
                // default
                fk_option_choice_id: "AFD27943-922E-4A41-B267-09BC39942F63",
                fk_option_choice_name: "",
                question_option_name: "",
                option_order: 0
            }]
        }]
    }])

    return (
        <SafeAreaView style={[styles.main]}>
            <ScrollView>
                <CustomSurvey
                    survey={survey}
                    setSurvey={setSurvey}
                    sectionQuestionList={sectionQuestionList}
                    setSectionQuestionList={setSectionQuestionList}
                    setShowResponseScreen={props.setShowResponseScreen}
                    setShowEditScreen={props.setShowEditScreen}
                    setShowCreateScreen={props.setShowCreateScreen}
                    setShowMySurveys={props.setShowMySurveys}
                    isCreate={1}
                    setShowSurveysAdmin={props.setShowSurveysAdmin}
                />
            </ScrollView>
        </SafeAreaView>
    );
}

const makeStyles = (colors) => StyleSheet.create({
    main: {
        flex: 1,
        width: '100%',
    },
})

export default CreateSurvey; 